var $ = require('jquery');

'use strict';

const FooterHamburger = {
	init() {
		this.setup();
	},
	setup() {
		this.$footer = $('.vc_section.footer');
		if (this.$footer.length === 0) { return; }
		this.$footer.addClass('c-footer-hamburger');
		this.addSectionTriggers();
		window.setTimeout(this.handleCareersLink.bind(this), 1000);
	},
	addSectionTriggers() {
		this.$footer.find('.vc_row.footer__top').find('.vc_column_container').each( (i, column) => {
			const $col = $(column);
			const $header = $('<div class="c-footer-hamburger__group-header"></div>');
			const $heading = $col.find('.footer__nav-heading:visible').each((i, el) => {
				const $$ = $(el);
				if ( $$.is(':visible') ) {
					$(el).wrap($header).after('<div class="c-footer-hamburger__indicator"><span class="ticon ticon-angle-down"></span></div>');
				}
			});
			const $navs = $col.find('.footer__menu');

			// Collapse $nav by default
			$navs.each( (i, el) => {
				$(el).removeClass('is-open');
			});

			// Expand/collapse $nav on $header click/tap
			const $nav_header = $heading.parent();
			$nav_header.removeClass('is-open');
			$nav_header.on('click', function (event) {
				$(event.delegateTarget).toggleClass('is-open');
				$navs.each( (i, el) => $(el).toggleClass('is-open') );
				// Close other open navs
				$col.siblings('.vc_column_container').each( (i, col) => {
					const $$ = $(col);
					$$.find('.is-open').removeClass('is-open');
				});
			});
		});
	},
	handleCareersLink() {
		let $careers_link = this.$footer.find('.js-footer-link--careers');

		const $footer = $careers_link.closest('.vc_section.footer');
		if ( $footer.length === 0 ) { console.error('no footer'); return; }

		const $col = $footer.find('.vc_column_container:first');
		if ( $col.length === 0 ) { console.error('no col'); return; }
		console.log('col', $col);

		const $nav_header = $col.find('.c-footer-hamburger__group-header');
		if ( $nav_header.length === 0 ) { console.error('no nav header'); return; }

		$careers_link = $careers_link.clone();
		$careers_link.removeClass('wpex-float-left');
		$careers_link.removeClass('js-footer-link--careers');
		$nav_header.before($careers_link);
		$careers_link.wrap('<div class="c-footer-hamburger__careers-link" />');
	},
};
$(FooterHamburger.init.bind(FooterHamburger));
